import { axiosInstance } from '@/shared/api/axios';

export type GetExecutiveResponseType = {
  executiveId: number;
  executiveName: string;
};

export type ExecutiveMasterResponse = {
  executives: GetExecutiveResponseType[];
};

export type GetRegistrationReasonResponseType = {
  id: number;
  description: string;
  registrationReasonType: string;
};

export type RegistrationReasonMasterResponse = {
  registrationReasons: GetRegistrationReasonResponseType[];
};

export const getExecutives = async (): Promise<GetExecutiveResponseType[]> => {
  const { data } = await axiosInstance.get<ExecutiveMasterResponse>('/touki/master/executives');
  return data.executives;
};

export const getRegistrationReasons = async (
  type: string,
): Promise<GetRegistrationReasonResponseType[]> => {
  const { data } = await axiosInstance.get<RegistrationReasonMasterResponse>(
    '/touki/master/registration-reasons',
    {
      params: {
        type,
      },
    },
  );
  return data.registrationReasons;
};
